// tslint:disable-next-line: import-blacklist
import dayjs from 'dayjs';
import Vue from 'vue';
import { mapErrors } from '@/utils/algoritms';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import * as Bowser from 'bowser';
import { pluralize } from '@/utils';
export { fixSafariReferer } from './algorithms';

dayjs.extend(customParseFormat);

const toStringDate = (value, precision) => {
  const str = value.toString();
  if (str.length < precision) {
    const prefix = '0'.repeat(precision - str.length);
    return `${prefix}${str}`;
  } else {
    return str;
  }
};

const prepareTimeStamp = (stamp: string): string => {
  const length = stamp.length;
  const offset = stamp.split('+')[1];
  switch (length) {
    case 26:
      return stamp.slice(0, -3);
    case 31:
      return stamp
        .slice(0, 23)
        .concat('+', offset);
    default:
      return stamp;
  }
};

const handler: any = {
  apply: (target, _, args) => {
    const years = new Date().getFullYear();
    const months = toStringDate(new Date().getMonth(), 2);
    const date = toStringDate(new Date().getDate(), 2);
    const hours = toStringDate(new Date().getHours(), 2);
    const minutes = toStringDate(new Date().getMinutes(), 2);
    const seconds = toStringDate(new Date().getSeconds(), 2);
    const milliseconds = toStringDate(new Date().getMilliseconds(), 3);
    const mantissa = `${years}-${months}-${date}T${hours}:${minutes}:${seconds}.${milliseconds}`;
    if (!!args && typeof args[0] === 'string') {
      const prepString = prepareTimeStamp(args[0]);
      const newArgs = args.slice(1);
      const [stamp, offset] = prepString.split('+');
      const str = `${stamp}${mantissa.slice(stamp.length)}`;
      return target(offset ? str.concat('+', offset) : str, ...newArgs);
    } else {
      return target(...args);
    }
  },
};

// ie11 not support proxy
// NOTE this code can given inaccurate calculations ie11
// because all calculations operates timestamp data? but server response
// some formatted date, for example '2001-01-01'
const createDate = typeof Proxy === 'undefined' ? dayjs : new Proxy(dayjs, handler);

Vue.prototype.$dayjs = createDate;

Vue.prototype.$mapErrors = mapErrors;

const browser = Bowser.getParser(window.navigator.userAgent);

Vue.prototype.$browser = browser.getBrowser();

Vue.prototype.$env = Bowser.parse(window.navigator.userAgent);

Vue.prototype.$isValidBrowser = isValidBrowser();

function isValidBrowser() {
  return !browser.satisfies({'internet explorer': '<=11'});
}

Vue.prototype.$pluralize = pluralize;

export { createDate };
